import { COLORS } from '@constants';
import { Typography } from '@ui';
import { Flex } from 'antd';
import styled from 'styled-components';

export const StyledFlex = styled(Flex)`
    max-width: 256px;
    width: 100%;
    justify-content: flex-end;
`;

export const StyledLineAccount = styled(Flex)`
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 24px 28px;
    gap: 24px;
    background: ${COLORS.$white};
    border: 1px solid ${COLORS.$gray15Black};
    border-radius: 8px;
    flex: none;
    flex-grow: 0;
`;

export const StyledLineCampaign = styled(Flex)`
    padding: 4px 0;
`;

export const StyledTitleWrapper = styled(Flex)`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
`;

export const StyledSubtitle = styled(Typography.Text)`
    color: ${COLORS.$gray60Black};
    font-size: 14px;
    line-height: 20px;
`;

export const StyledStatusAccount = styled(Flex)`
    gap: 26px;
    align-items: center;
`;

export const StyledStatusCampaign = styled(Flex)`
    width: 100%;
    justify-content: space-between;
`;

export const StyledText = styled(Typography.Text)`
    display: flex;
    align-items: center;
    gap: 8px;
`;
